export default __webpack_public_path__ + "static/media/integration.961b1513.webp";